import React, { useState, useRef, useLayoutEffect } from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';

import {
  Container,
  InputLabel,
  Root,
  Content,
  NotchedOutline,
} from './OutlinedContainer.styled';
/**
 *
 * A styled notched container for providing textfield-type styling for arbitrary components.
 * Useful for wrapping custom text editors (e.g. th90 and aula-editor) to have the textfield type border and label
 */
const OutlinedContainer = ({ id, label, children, onClick }) => {
  const [labelWidth, setLabelWidth] = useState(0);
  const [focused, setFocused] = useState(false);
  const labelRef = useRef(null);

  useLayoutEffect(() => {
    const labelNode = findDOMNode(labelRef.current);
    setLabelWidth(labelNode != null ? labelNode.offsetWidth : 0);
  }, [label]);

  return (
    <ClickAwayListener onClickAway={() => setFocused(false)}>
      <Container>
        <InputLabel
          ref={labelRef}
          htmlFor={id}
          variant="outlined"
          shrink
          focused={focused}
        >
          {label}
        </InputLabel>
        <Root>
          <Content
            aria-label={label}
            id={id}
            onClick={() => {
              setFocused(true);
              onClick();
            }}
          >
            {children}
            <NotchedOutline
              notched
              labelWidth={labelWidth}
              focused={+focused}
            />
          </Content>
        </Root>
      </Container>
    </ClickAwayListener>
  );
};

OutlinedContainer.propTypes = {
  /** Unique ID */
  id: PropTypes.string.isRequired,

  /** Label that will be displayed on the notched outline */
  label: PropTypes.string.isRequired,

  /** onClick event that will be called when the contents of the container have been clicked */
  onClick: PropTypes.func,

  /** The content of the outlined container */
  children: PropTypes.node,
};

OutlinedContainer.defaultProps = {
  onClick: () => {},
  children: null,
};

export default React.memo(OutlinedContainer);
